import { Trans } from "@lingui/react/macro";

import type { MatchFilters } from "../../lib/matchFiltersSchema";
import { FilterGroup } from "./FilterGroup";

type ExtraFiltersProps = {
  id: string;
  filters: MatchFilters;
  onChange: (patch: Partial<MatchFilters>) => void;
};

// Панель «Ещё фильтры»: разбор, длительность, смерти, место в матче. «Все» — фильтр выключен.
export const ExtraFilters = ({ id, filters, onChange }: ExtraFiltersProps) => (
  <div
    id={id}
    className="grid grid-cols-[repeat(auto-fit,minmax(230px,1fr))] gap-3 rounded-[10px] border border-border bg-background p-3.5"
  >
    <FilterGroup
      label={<Trans>Analysis</Trans>}
      value={filters.analyzed ?? "all"}
      options={[
        { value: "all", label: <Trans>All</Trans> },
        { value: "yes", label: <Trans>Analyzed</Trans> },
        { value: "no", label: <Trans>Not analyzed</Trans> },
      ]}
      onChange={(analyzed) => {
        onChange({ analyzed: analyzed === "all" ? undefined : analyzed });
      }}
    />
    <FilterGroup
      label={<Trans>Duration</Trans>}
      value={filters.duration ?? "all"}
      options={[
        { value: "all", label: <Trans context="duration">Any</Trans> },
        { value: "short", label: <Trans>under 30 min</Trans> },
        { value: "mid", label: <Trans>30–40 min</Trans> },
        { value: "long", label: <Trans>40+ min</Trans> },
      ]}
      onChange={(duration) => {
        onChange({ duration: duration === "all" ? undefined : duration });
      }}
    />
    <FilterGroup
      label={<Trans>Deaths</Trans>}
      value={filters.deaths ?? "all"}
      options={[
        { value: "all", label: <Trans context="deaths">Any</Trans> },
        { value: "many", label: <Trans>10 or more</Trans> },
      ]}
      onChange={(deaths) => {
        onChange({ deaths: deaths === "all" ? undefined : deaths });
      }}
    />
    <FilterGroup
      label={<Trans>Place in match</Trans>}
      value={filters.place ?? "all"}
      options={[
        { value: "all", label: <Trans context="place">Any</Trans> },
        { value: "mvp", label: <Trans>MVP</Trans> },
        { value: "top", label: <Trans>Top 3</Trans> },
      ]}
      onChange={(place) => {
        onChange({ place: place === "all" ? undefined : place });
      }}
    />
  </div>
);
